import { MaskText } from "./Reveal";
import { scrollToId } from "./SmoothScroll";

export default function Footer({ onConsult }) {
  return (
    <footer className="bg-[var(--ink)] text-[var(--bone)] pt-24 sm:pt-40 pb-10" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="border-b border-white/10 pb-16 sm:pb-24 flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <MaskText
            as="h2"
            lines={["Ready when", "your skin is."]}
            className="font-display text-6xl sm:text-8xl lg:text-[8vw] leading-[0.82] tracking-tighter"
          />
          <div className="flex gap-3">
            <button onClick={onConsult} className="btn-ink !bg-[var(--bone)] !text-[var(--ink)] px-8 py-4 rounded-full" data-testid="footer-consult-btn">
              Start consult
            </button>
            <button onClick={() => scrollToId("skin")} className="btn-outline !border-white/40 !text-[var(--bone)] px-8 py-4 rounded-full" data-testid="footer-shop-btn">
              Shop
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-14">
          <div>
            <span className="font-display text-3xl">Balance <span className="text-[var(--terra)]">+ Beauty</span></span>
            <p className="font-body text-sm text-white/50 mt-4 max-w-[16rem]">
              Clinical skin, wellness &amp; research compounds. Below market. No subscription.
            </p>
          </div>
          {[
            { h: "Shop", items: [["Skin", "skin"], ["Wellness", "wellness"], ["Weight", "program"], ["Research", "peptides"]] },
            { h: "Company", items: [["Consult", "intake"], ["Wholesale", "wholesale"]] },
          ].map((col) => (
            <div key={col.h}>
              <p className="overline text-white/40 mb-5">{col.h}</p>
              <ul className="space-y-3">
                {col.items.map(([label, id]) => (
                  <li key={id}>
                    <button onClick={() => scrollToId(id)} className="font-body text-white/70 hover:text-[var(--bone)] transition-colors">
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <p className="overline text-white/40 mb-5">Pay with</p>
            <ul className="space-y-3 font-mono text-sm text-white/70">
              <li>Venmo · @Balance-beauty</li>
              <li>Cash App · $thegeorgegroup</li>
              <li>Chime · $BalancePep</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-mono text-xs text-white/40 max-w-2xl leading-relaxed">
            © 2024 Balance. Research compounds are for laboratory research only and not for human consumption. Skin products are not evaluated to diagnose or treat disease. Consult a professional before use.
          </p>
          <p className="font-mono text-xs text-white/40">Built for glow.</p>
        </div>
      </div>
    </footer>
  );
}
